import React from 'react'
import logoImg from '../../images/Rokyet-ventures-no-bg.png'

const Header = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <header>
      <div className='container header-container'>
        <div className='logo'>
          <img
            src={logoImg}
            alt='Rokyet Ventures'
            style={{ height: 40, marginRight: 10 }}
          />
          <div className='logo-text-block'>
            <div className='logo-text'>Rokyet Ventures Ltd</div>
            <div className='logo-slogan'>
              Custom Solutions. Made Simple. Made Right
            </div>
          </div>
        </div>
        <nav>
          <ul className='nav-menu'>
            <li>
              <a
                href='#home'
                onClick={(e) => {
                  e.preventDefault()
                  scrollTo('home')
                }}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href='#about'
                onClick={(e) => {
                  e.preventDefault()
                  scrollTo('about')
                }}
              >
                About
              </a>
            </li>
            <li>
              <a
                href='#services'
                onClick={(e) => {
                  e.preventDefault()
                  scrollTo('services')
                }}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href='#aropmis'
                onClick={(e) => {
                  e.preventDefault()
                  scrollTo('aropmis')
                }}
              >
                AroPMIS
              </a>
            </li>
            <li>
              <a
                href='#contact'
                onClick={(e) => {
                  e.preventDefault()
                  scrollTo('contact')
                }}
              >
                Contact
              </a>
            </li>
          </ul>
          <div className='mobile-menu-btn'>
            <i className='fas fa-bars'></i>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header
